<template>
    <div>
<!--        <perfect-scrollbar ref="locationSidebar">-->
            <aut-location-card
                v-for="location in locations"
                :key="location.id"
                :location="location"
                :event-bus="eventBus"
            ></aut-location-card>

            <div v-if="loading" class="loading" style="height: 50px; margin-top: 2rem;"></div>
<!--        </perfect-scrollbar>-->
    </div>
</template>

<script>
import Card from "./Card";

export default {
    name: "SideBar",

    components: {
        'aut-location-card': Card
    },

    props: {
        locations: {
            type: Array
        },
        eventBus: {},
        loading: {
            type: Boolean
        }
    },
}
</script>
